module.exports = __webpack_public_path__ + "img/vip5.2b986460.svg";